import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Children, Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ScrollContainer } from "../ScrollContainer";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);
  var _super = _createSuper(Tabs);
  function Tabs(props) {
    var _this;
    _classCallCheck(this, Tabs);
    _this = _super.call(this, props);
    var children = props.children,
      activeTab = props.activeTab;
    var tabChildren = Children.toArray(children);

    // fix strange bug
    if (typeof tabChildren.find === 'function') {
      var tabsList = tabChildren.find(function (child) {
        return child.type.componentName === 'TabsList';
      });
      var tabsListChildren = Children.toArray(tabsList.props.children);
      _this.state = {
        activeTab: activeTab || (tabsListChildren[0] ? tabsListChildren[0].props.id : 0)
      };
    } else {
      _this.state = {
        activeTab: 0
      };
    }
    _this.setActiveTab = _this.setActiveTab.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Tabs, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.activeTab !== nextProps.activeTab) {
        this.setState({
          activeTab: nextProps.activeTab
        });
      }
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(id) {
      if (!this.state) return;
      this.setState({
        activeTab: id
      });
      if (this.props.onChange) {
        this.props.onChange(id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state) return null;
      var activeTab = this.state.activeTab;
      var _this$props = this.props,
        disabled = _this$props.disabled,
        disableHiddenRendering = _this$props.disableHiddenRendering,
        className = _this$props.className,
        children = _this$props.children;
      var mappedChildren = Children.map(children, function (child) {
        var isHidden = child.props.id !== activeTab;
        switch (child.type.componentName) {
          case 'TabContent':
            return disableHiddenRendering && isHidden ? null : /*#__PURE__*/cloneElement(child, {
              isHidden: isHidden
            });
          case 'TabsList':
            return /*#__PURE__*/cloneElement(child, {
              activeTab: activeTab,
              handleTabClick: _this2.setActiveTab,
              disabled: disabled
            });
          default:
            return null;
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        "data-t-id": "components-Tabs"
      }, mappedChildren);
    }
  }]);
  return Tabs;
}(Component);
Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  disableHiddenRendering: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string
} : {};
export function TabContent(props) {
  var children = props.children,
    className = props.className,
    isHidden = props.isHidden;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className),
    style: isHidden ? {
      display: 'none'
    } : null
  }, children);
}
TabContent.componentName = 'TabContent';
TabContent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  isHidden: PropTypes.bool,
  className: PropTypes.string
} : {};
export var TabsList = /*#__PURE__*/function (_Component2) {
  _inherits(TabsList, _Component2);
  var _super2 = _createSuper(TabsList);
  function TabsList() {
    var _this3;
    _classCallCheck(this, TabsList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this3 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "scrollToTab", function (target, immediate) {
      if (_this3.props.autoScroll) {
        var _target$getBoundingCl = target.getBoundingClientRect(),
          left = _target$getBoundingCl.left,
          width = _target$getBoundingCl.width;
        _this3.wrapper.scrollBy({
          left: left + width / 2 - window.innerWidth / 2,
          behavior: immediate ? 'auto' : 'smooth'
        });
      }
    });
    return _this3;
  }
  _createClass(TabsList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      setTimeout(function () {
        _this4.scrollToTab(_this4.wrapper.querySelector(".".concat(cx('active'))), true);
      });
      window.scrollToTab = this.scrollToTab;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      if (!this.props) return null;
      var _this$props2 = this.props,
        activeTab = _this$props2.activeTab,
        handleTabClick = _this$props2.handleTabClick,
        type = _this$props2.type,
        disabled = _this$props2.disabled,
        className = _this$props2.className,
        inline = _this$props2.inline,
        theme = _this$props2.theme,
        stretched = _this$props2.stretched,
        scrollContainer = _this$props2.scrollContainer;
      var children = Children.map(this.props.children, function (child) {
        var id = child.props.id;
        var newProps = {
          type: type
        };
        if (activeTab) {
          if (id === activeTab) newProps.active = true;
          if (id !== activeTab && !disabled) {
            newProps.handleClick = function (e) {
              _this5.scrollToTab(e.currentTarget);
              handleTabClick(id);
            };
          }
        }
        return /*#__PURE__*/cloneElement(child, newProps);
      });
      var Wrapper = scrollContainer && type !== 'radio' ? ScrollContainer : 'div';
      return /*#__PURE__*/React.createElement(Wrapper, {
        className: cx('tabsWrapper', className),
        ref: function ref(e) {
          _this5.wrapper = e;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(type, {
          inline: inline,
          stretched: stretched
        }, theme && "".concat(theme, "Theme")),
        "data-t-id": "components-Tabs"
      }, children));
    }
  }]);
  return TabsList;
}(Component);
TabsList.componentName = 'TabsList';
TabsList.defaultProps = {
  type: 'calendar',
  autoScroll: false,
  scrollContainer: false
};
TabsList.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.array.isRequired,
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inline: PropTypes.bool,
  theme: PropTypes.string,
  stretched: PropTypes.bool,
  handleTabClick: PropTypes.func,
  type: PropTypes.oneOf(['calendar', 'radio', 'segmented', 'monorail']),
  disabled: PropTypes.bool,
  autoScroll: PropTypes.bool,
  scrollContainer: PropTypes.bool,
  className: PropTypes.string
} : {};
export var Tab = /*#__PURE__*/function (_Component3) {
  _inherits(Tab, _Component3);
  var _super3 = _createSuper(Tab);
  function Tab() {
    var _this6;
    _classCallCheck(this, Tab);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this6 = _super3.call.apply(_super3, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this6), "handleClick", function (event) {
      var _this6$props = _this6.props,
        handleClick = _this6$props.handleClick,
        onClick = _this6$props.onClick;
      if (handleClick) handleClick(event);
      if (onClick) onClick();
    });
    return _this6;
  }
  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _cx;
      var _this$props3 = this.props,
        children = _this$props3.children,
        active = _this$props3.active,
        href = _this$props3.href,
        type = _this$props3.type,
        className = _this$props3.className;
      var Tag = href ? 'a' : 'button';
      if (active) Tag = 'div';
      var elClassName = cx(className, (_cx = {
        tab: true
      }, _defineProperty(_cx, type, true), _defineProperty(_cx, "active", active), _cx));
      return /*#__PURE__*/React.createElement(Tag, {
        className: elClassName,
        "data-component": "Tab",
        href: href,
        onClick: this.handleClick
      }, type === 'radio' ? /*#__PURE__*/React.createElement("div", {
        className: cx('stateCircle')
      }) : null, children);
    }
  }]);
  return Tab;
}(Component);
Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]).isRequired,
  active: PropTypes.bool,
  autoScroll: PropTypes.bool,
  handleClick: PropTypes.func,
  onClick: PropTypes.func,
  href: PropTypes.string,
  type: PropTypes.oneOf(['calendar', 'radio', 'segmented', 'monorail']),
  className: PropTypes.string
} : {};